// AssessmentResultsPage.js
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';
import { PDFExport } from '@progress/kendo-react-pdf';
import resumeBeen from '../../../image/resumebeen.svg';
import { API_URL } from '../../../apiConfig';
import sanitizeHtml from 'sanitize-html';
import userIcon from '../../../image/user.png';
import poster from '../../../image/poster.png';
import PDFContent from './PDFContent'; // Import the new component
import './AssessmentResultsPage.css';

const AssessmentResultsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [attempts, setAttempts] = useState([]);
  const [assessmentres, setAssessmentres] = useState([]);
  const [assessmentTitle, setAssessmentTitle] = useState('Assessment Results');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [exportAttempt, setExportAttempt] = useState(null);
  const pdfExportComponent = useRef(null);

  // CSV data preparation
  const csvData = attempts.map((attempt) => ({
    'User Name': attempt.userName || 'Unknown',
    
    'Score Achieved': attempt.score,
    'Total Scored': attempt.totalQuestions,
    'Submitted At': new Date(attempt.submittedAt).toLocaleString(),
  }));

  const csvHeaders = [
    { label: 'User Name', key: 'User Name' },
    { label: 'Score Achieved', key: 'Score Achieved' },
    { label: 'Total Scored', key: 'Total Scored' },
    { label: 'Submitted At', key: 'Submitted At' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching attempts for assessment ID:', id);
        const [attemptsResponse, assessmentResponse] = await Promise.all([
          axios.get(`${API_URL}/api/v1/admin/assessments/${id}/results`, {
            withCredentials: true,
          }),
          axios.get(`${API_URL}/api/v1/admin/assessments/${id}`, {
            withCredentials: true,
          }),
        ]);

        console.log('Attempts response:', attemptsResponse.data);
        if (!attemptsResponse.data.success) {
          throw new Error(attemptsResponse.data.message || 'Failed to fetch assessment attempts');
        }
        setAttempts(attemptsResponse.data.data);
        setAssessmentres(assessmentResponse.data.assessment);
        console.log('Assessment response1:', assessmentResponse.data.assessment.title);
        console.log('Assessment response:', assessmentResponse.data);
        
        if (assessmentResponse.data.success) {
          setAssessmentTitle(assessmentResponse.data.data.title || 'Assessment Results');
        }
      } catch (err) {
        console.error('Fetch error:', {
          message: err.message,
          response: err.response?.data,
          status: err.response?.status,
        });
        setError(err.message || 'Error fetching data');
        toast.error(err.message || 'Error fetching data', { autoClose: 2500 });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

   const sanitizeDescription = (html) => {
      return sanitizeHtml(html, {
        allowedTags: ['p', 'b', 'i', 'u', 's', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'blockquote', 'table', 'tr', 'td', 'th', 'strong', 'em'],
        allowedAttributes: {
          a: ['href'],
          table: ['border'],
          td: ['colspan', 'rowspan'],
          th: ['colspan', 'rowspan'],
        },
      });
    };
  
    // Render sanitized HTML
    const renderHTML = (html) => {
      const sanitizedHTML = sanitizeDescription(html);
      return { __html: sanitizedHTML };
    };

  useEffect(() => {
    if (exportAttempt && pdfExportComponent.current) {
      console.log('Exporting PDF for attempt:', exportAttempt.userId);
      pdfExportComponent.current.save(() => {
        console.log('PDF saved, resetting export attempt');
        setExportAttempt(null);
      });
    } else if (exportAttempt && !pdfExportComponent.current) {
      console.error('PDFExport component ref is not available');
      setExportAttempt(null);
    }
  }, [exportAttempt]);

  const toggleRow = (userId) => {
    setExpandedRow(expandedRow === userId ? null : userId);
  };

  const downloadPDF = (attempt) => {
    console.log('Initiating PDF download for attempt:', attempt.userId);
    setExportAttempt(attempt);
  };

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours > 0 ? `${hours}h ` : ''}${mins}m`;
  };

  const formatDurationsec = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;
    return `${hours > 0 ? `${hours}h ` : ''}${mins}m ${sec}s`;
  };

  const PdfPageTemplate = (props) => {
    const isFirstPage = props.pageNum === 1;
    return (
      <div>
        {isFirstPage ? (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${poster})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              padding: '1cm',
            }}
          >
            <div>
              <div className='mb-5'>
                  <img
                    src={resumeBeen}
                    alt="ResumeBeen Logo"
                    style={{
                      height: '40px',
                      objectFit: 'contain',
                    }}
                  />
              </div>
              <div>
                <h1 className=" font-montserrat font-semibold text-black mb-4" style={{fontSize:"24px"}}>
                  {assessmentres.title || ' '}
                </h1>
              </div>
            </div>
            
          </div>
        ) : (
          <>
            <div
              style={{
                position: 'absolute',
                top: '1cm',
                left: '1cm',
                right: '1cm',
                height: '50px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <img
                src={resumeBeen}
                alt="Header Logo"
                style={{
                  height: '32px',
                  objectFit: 'contain',
                }}
              />
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: '1cm',
                left: '1cm',
                right: '1cm',
                height: '30px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '16px',
                color: '#333',
              }}
            >
              <h2 style={{ margin: 0 }}>Assessment Result</h2>
              <a href="https://resumebeen.com/" style={{ textDecoration: 'none', color: '#333' }}>
                https://resumebeen.com/
              </a>
            </div>
          </>
        )}
      </div>
    );
  };
const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  };

  let formatted = date.toLocaleString('en-IN', options);

  // Force am/pm to uppercase
  formatted = formatted.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());

  return formatted;
};



  const renderAttemptDetails = (attempt) => (
    <div className="bg-white p-6">
      <div className='mb-3'>
              <h1 style={{ fontSize: '30px' }}>Test Taker Details</h1>
      </div>
      <p className='mb-4' style={{ borderBottom: '2px solid #ccc', width: '100%', margin: 0 }}></p>
      <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent:'space-between' }}>
        <button
          style={{
            backgroundColor: '#22c55e', // Tailwind green-500
            color: '#fff',
            fontSize: '24px',
            padding: '8px 16px',
            border: 'none',
            borderRadius: '9999px', // pill shape
            cursor: 'default',

            fontWeight: '600',
            // transition: 'transform 0.2s',
          }}
        
        >
          Score: {attempt.score}/{attempt.totalQuestions}
        </button>
        <p className="text-lg font-montserrat font-semibold text-red-500">
            Test Finish Time: {formatDateTime(attempt.submittedAt)}
          </p>
      
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}> */}
      <div className='mb-4' style={{border:'1px solid'}}>
        <div className="flex items-center bg-gray-50" style={{borderBottom:'1px solid'}} >
          <div className='p-4 flex items-center col-12 '>
            <div className='col-md-1 justify-center flex items-center'>
                <img
                        src={attempt.profilePic || userIcon}
                    alt="User Icon"
                    className="w-14 h-14 mr-2 rounded-full object-cover"
                    onError={(e) => {
                    e.target.src = userIcon; // Fallback to default icon on error
                    }}
                />
            </div>
            <div className='col-md-11 justify-start grid items-center'>
                <div className=''>
                    <h3 className="text-xl font-montserrat font-semibold text-black">
                        {(attempt.userName || '') + ' ' + (attempt.lastName || '')}
                    </h3>
                </div>
                <div className=' '>
                      <p className='text-xl font-montserrat font-semibold text-black'> Email id : {attempt.email} </p>
                </div>
            </div>
          </div>    
        </div>
        <div className='p-3'>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div className="flex ">
                          <h4 className="text-sm font-semibold text-gray-900 mb-2">Difficulty Level:</h4>
                          <p className="text-sm text-gray-600">{assessmentres.difficultyLevel || 'N/A'}</p>
                        </div>
                        <div className="flex ">
                          <h4 className="text-sm font-semibold text-gray-900 mb-2">Assessment Type:</h4>
                          <p className="text-sm text-gray-600">{assessmentres.assessmentType || 'N/A'}</p>
                        </div>
                        <div className="flex ">
                          <h4 className="text-sm font-semibold text-gray-900 mb-2">Total Time Duration:</h4>
                          <p className="text-sm text-gray-600">{formatDuration(assessmentres.duration) || 'N/A'}</p>
                        </div>
                        <div className="flex ">
                          <h4 className="text-sm font-semibold text-gray-900 mb-2">Attempt Time Duration:</h4>
                          <p className="text-sm text-gray-600">{formatDurationsec(attempt.timeDuration) || 'N/A'}</p>
                        </div>
                      </div>
        </div>
      </div> 
            <div style={{ marginBottom: '16px' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>
                Description:
              </h4>
              <div
                style={{ fontSize: '14px', color: '#000' }}
                dangerouslySetInnerHTML={
                  assessmentres.description
                    ? renderHTML(assessmentres.description)
                    : { __html: '<p>No description provided.</p>' }
                }
              />
            </div>
           


      <div className="space-y-6">
        <div className='mb-3'>
              <h1 style={{ fontSize: '30px' }}>Candidate Response</h1>
         </div>
            <p className='mb-4' style={{ borderBottom: '2px solid #ccc', width: '100%', margin: 0 }}></p>
        {attempt.answers.map((ans, idx) => {
          const userSelected = ans.selectedOptions || [];
          const correctAnswers = ans.question.correctAnswers || [];
          const hasCorrectAnswers = correctAnswers.length > 0;
          const options = ans.question.options || [];
          const isCodingQuestion = ans.question.type === 'coding';

          return (
            <div
              key={idx}
              className="border border-gray-200 rounded-lg p-4 bg-gray-50"
            >
              <p className="text-lg font-montserrat text-gray-700 font-semibold mb-3">
                Question {idx + 1}: {isCodingQuestion ? ans.question.codingText || 'Coding Question' : ans.question.questionText || 'Question Text Unavailable'}
              </p>
              {isCodingQuestion ? (
                <div className="space-y-4">
                  <div>
                    <p className="text-sm font-montserrat text-gray-600 mb-1">
                      Language: {ans.language || 'N/A'} ({ans.version || 'N/A'})
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-montserrat text-gray-600 mb-1">Submitted Code:</p>
                    <pre className="bg-gray-900 text-gray-200 p-4 rounded-md text-sm font-mono overflow-auto max-h-60">
                      {ans.code || 'No code submitted'}
                    </pre>
                  </div>
                  <div>
                    <p className="text-sm font-montserrat text-gray-600 mb-1">Output:</p>
                    <pre className="bg-gray-900 text-gray-200 p-4 rounded-md text-sm font-mono overflow-auto max-h-60">
                      {ans.output || 'No output generated'}
                    </pre>
                  </div>
                </div>
              ) : (
                <>
                  {!hasCorrectAnswers && (
                    <p className="text-sm font-montserrat text-red-500 mb-2">
                      Correct answers not available for this question.
                    </p>
                  )}
                  {options.length === 0 && (
                    <p className="text-sm font-montserrat text-red-500 mb-2">
                      Options not available for this question.
                    </p>
                  )}
                  <div className="space-y-2">
                    {options.map((option, optIdx) => {
                      const isSelected = userSelected.includes(optIdx);
                      const isCorrect = correctAnswers.includes(optIdx);
                      return (
                        <div
                          key={optIdx}
                          className={`flex items-center space-x-3 p-3 rounded-lg border ${
                            isCorrect && hasCorrectAnswers
                              ? 'bg-green-100 border-green-300'
                              : isSelected && hasCorrectAnswers
                              ? 'bg-red-100 border-red-300'
                              : 'bg-white border-gray-200'
                          }`}
                        >
                          <input
                            type={ans.question.type === 'single' ? 'radio' : 'checkbox'}
                            checked={isSelected}
                            disabled
                            className="h-5 w-5 text-blue-600 focus:ring-blue-500"
                          />
                          <span className="text-gray-700 font-montserrat flex-grow">
                            {option}
                          </span>
                          {isCorrect && hasCorrectAnswers && (
                            <i className="fas fa-check text-green-500" aria-label="Correct answer"></i>
                          )}
                          {isSelected && !isCorrect && hasCorrectAnswers && (
                            <i className="fas fa-times text-red-500" aria-label="Incorrect selection"></i>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen bg-gray-100">
        <div className="flex-grow flex items-center justify-center">
          <div className="text-blue-600 text-xl animate-pulse">Loading...</div>
        </div>
      </div>
    );
  }

  if (error && attempts.length === 0) {
    return (
      <div className="flex flex-col min-h-screen bg-gray-100">
        <div className="flex-grow flex items-center justify-center">
          <div className="bg-red-100 text-red-700 p-6 rounded-xl shadow-lg">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <main className="flex-grow p-6 max-w-7xl">
        {error && (
          <div className="bg-red-100 text-red-700 p-4 rounded-xl mb-6">{error}</div>
        )}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-montserrat font-bold text-gray-800">
            {assessmentTitle}
          </h2>
          <div className="space-x-4">
            <CSVLink
              data={csvData}
              headers={csvHeaders}
              filename={`assessment_results_${id}.csv`}
              className="bg-green-600 text-white px-6 py-2 rounded-full font-montserrat text-sm hover:bg-green-700 transition"
            >
              Export as CSV
            </CSVLink>
            <button
              onClick={() => navigate('/admin/assessments')}
              className="bg-blue-600 text-white px-6 py-2 rounded-full font-montserrat text-sm hover:bg-blue-700 transition"
            >
              Back to Assessments
            </button>
          </div>
        </div>
        {attempts.length === 0 ? (
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <p className="text-gray-600 font-montserrat text-lg">No attempts found for this assessment.</p>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h3 className="text-xl font-montserrat font-semibold text-blue-600 mb-4">
              {assessmentTitle}
            </h3>
            <table className="w-full table-auto">
              <thead>
                <tr className="bg-gray-200">
                  <th className="px-4 py-2 text-left font-montserrat text-gray-700">User Name</th>
                  <th className="px-4 py-2 text-left font-montserrat text-gray-700">Attempts Made</th>
                  <th className="px-4 py-2 text-left font-montserrat text-gray-700">Score</th>
                  <th className="px-4 py-2 text-left font-montserrat text-gray-700">Submitted At</th>
                  <th className="px-4 py-2 text-left font-montserrat text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody>
                {attempts.map((attempt) => (
                  <React.Fragment key={attempt.userId}>
                    <tr
                      className="border-b cursor-pointer hover:bg-gray-50"
                      onClick={() => toggleRow(attempt.userId)}
                    >
                      <td className="px-4 py-2 font-montserrat text-gray-600">
                        {attempt.userName || 'Unknown'}
                      </td>
                      <td className="px-4 py-2 font-montserrat text-gray-600">
                        {attempt.attemptsMade}
                      </td>
                      <td className="px-4 py-2 font-montserrat text-gray-600">
                        {attempt.score}/{attempt.totalQuestions}
                      </td>
                      <td className="px-4 py-2 font-montserrat text-gray-600">
                        {new Date(attempt.submittedAt).toLocaleString()}
                      </td>
                      <td className="px-4 py-2 flex space-x-2">
                        <button
                          type="button"
                          style={{
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            padding: '4px 12px',
                            border: 'none',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                            fontWeight: 500,
                            fontFamily: 'Montserrat, sans-serif',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleRow(attempt.userId);
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1d4ed8')}
                          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#2563eb')}
                          aria-label={`View results for ${attempt.userName || 'user'}`}
                        >
                          View Result
                        </button>
                        <button
                          type="button"
                          style={{
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            padding: '4px 12px',
                            border: 'none',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                            fontWeight: 500,
                            fontFamily: 'Montserrat, sans-serif',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadPDF(attempt);
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1d4ed8')}
                          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#2563eb')}
                          aria-label={`Download PDF for ${attempt.userName || 'user'}`}
                        >
                          Download Result
                        </button>
                      </td>
                    </tr>
                    {expandedRow === attempt.userId && (
                      <tr className="keep-together">
                        <td colSpan={5} className="px-4 py-4 bg-gray-50">
                          {renderAttemptDetails(attempt)}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {exportAttempt && (
          <div style={{ position: 'absolute', left: '-9999px' }}>
            <PDFExport
              ref={pdfExportComponent}
              paperSize="A4"
              margin={{ top: '2.5cm', left: '1cm', right: '1cm', bottom: '1cm' }}
              fileName={`${assessmentTitle}_${exportAttempt.userName || 'Unknown'}_Details.pdf`}
              scale={0.7}
              keepTogether=".keep-together"
              pageTemplate={PdfPageTemplate}
            >
              <div style={{ height: '842pt', pageBreakAfter: 'always' }} />
              <PDFContent
                attempt={exportAttempt}
                assessment={assessmentres}
                renderHTML={renderHTML}
                formatDuration={formatDuration}
                formatDurationsec={formatDurationsec}
              />
            </PDFExport>
          </div>
        )}
      </main>
    </div>
  );
};

export default AssessmentResultsPage;